import React from 'react'
import {connect} from 'react-redux'

import DesignApp from './designApp'

const mapStateToProps = ( state, props ) => ({
	tiles : state.tiles,
	colorScheme: state.colorScheme,
	selectedTile: state.selectedTile,
	currentColors: state.currentColors,
	selectedPath: state.selectedPath,
	selectedColor: state.selectedColor,
	colors: state.colors
});

const VisibleDesignApp = connect( mapStateToProps, null )(DesignApp)

export default VisibleDesignApp;


// WEBPACK FOOTER //
// ./src/components/mosaic/visibleDesignApp.jsx